import { PAGE_SIZE } from 'academy-common-lib/features/pagination/paginationConsts';
export const PLAYLIST_SEARCH_RESULTS_SIZE = PAGE_SIZE;